import { makeStyles, shorthands, tokens } from "@fluentui/react-components";
import { ellipsis, ellipsisMultiline } from "@/common/style/commonStyle";
import { MEDIA_QUERIES } from "@/hooks/responsive";

export const useStyle = makeStyles({
	container: {
		minWidth: "10rem",
		maxWidth: "30rem",
		width: "23rem",
		padding: "10px 14px 14px 14px",

		[`@media ${MEDIA_QUERIES.isMobileMediumToSmall}`]: {
			width: "22rem",
		},
	},
	title: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightBold,
		marginLeft: "12px",
	},
	subTitle: {
		fontSize: tokens.fontSizeBase200,
		fontWeight: tokens.fontWeightSemibold,
		marginBottom: "8px",
		marginTop: "5px",
	},
	commentInput: {
		fontSize: tokens.fontSizeBase200,
		marginBottom: "8px",
		marginTop: "5px",
	},
	noteInput: {
		backgroundColor: tokens.colorNeutralBackground4,
	},
	noteField: {
		marginBottom: "16px",
	},
	button: {
		minWidth: "65px",
	},
	ellipsis: {
		...ellipsis(),
	},
	noteText: {
		maxHeight: "40px",
		textWrap: "wrap",
		overflowWrap: "anywhere",
		...ellipsisMultiline(2),
		fontSize: tokens.fontSizeBase200,
		whiteSpace: "pre-line",
	},
	noteTextContainer: {
		paddingRight: "5px",
		marginBottom: "8px",
	},
	noteTitle: {
		marginBottom: "3px",
		color: tokens.colorNeutralForeground2,
	},
	noteAuthorName: {
		maxWidth: "180px",
	},
	noteTooltip: {
		whiteSpace: "pre-line",
	},
	notesContainer: {
		maxHeight: "150px",
		...shorthands.overflow("scroll"),
	},
	panelHeader: {
		...shorthands.padding("0px"),
		marginBottom: tokens.spacingHorizontalS,
	},
	expanded: {
		WebkitLineClamp: "unset",
		maxHeight: "unset",
	},
	showMore: {
		background: "none",
		border: "none",
		padding: 0,
		color: tokens.colorBrandBackgroundHover,
		cursor: "pointer",
		fontSize: tokens.fontSizeBase200,
	},
});
